import { FilterState } from './filter-state';
import { FiltersAction } from './filters-action.interface';
import { FiltersActions } from './filters-actions.enum';
import { clearReducer } from './reducers/clear-reducer';
import { optOutReducer } from './reducers/opt-out.reducer';
import { setDateRangeFromReducer } from './reducers/set-date-range-from.reducer';
import { setDateRangeToReducer } from './reducers/set-date-range-to-reducer';
import { toggleActiveReducer } from './reducers/toggle-active-reducer';
import { toggleExpandedReducer } from './reducers/toggle-expanded-reducer';
import { toggleShowReducer } from './reducers/toggle-show-reducer';
import { updateAggregationsReducer } from './reducers/update-aggregations.reducer';
import { setActiveFiltersReducer } from './set-active-filters.reducer';

export const REDUCER_MAP: {
  [key in FiltersActions]: (state: FilterState, action: FiltersAction) => FilterState;
} = {
  [FiltersActions.UPDATE_AGGREGATIONS]: updateAggregationsReducer,
  [FiltersActions.UPDATE_AGGREGATIONS_SUCCESS]: optOutReducer,
  [FiltersActions.UPDATE_AGGREGATIONS_ERROR]: optOutReducer,
  [FiltersActions.CLEAR]: clearReducer,
  [FiltersActions.TOGGLE_SHOW]: toggleShowReducer,
  [FiltersActions.SET_DATE_RANGE_FROM]: setDateRangeFromReducer,
  [FiltersActions.SET_DATE_RANGE_TO]: setDateRangeToReducer,
  [FiltersActions.SET_ACTIVE_FILTERS]: setActiveFiltersReducer,
  [FiltersActions.TOGGLE_ACTIVE]: toggleActiveReducer,
  [FiltersActions.TOGGLE_EXPANDED]: toggleExpandedReducer,
};
